/* eslint-disable import/extensions */

import {
  webBorrowerPortalService,
  webDrawService
} from "./mfe-remotes-config/remoteConfig.js";

window[webBorrowerPortalService.urlGlobalVariable] =
  webBorrowerPortalService.url;

window[webDrawService.urlGlobalVariable] = webDrawService.url;

import("./bootstrap.jsx");
